<template>
<b-table @row-clicked="rowClicked" class="tree-table" small hover :items="filteredData" :fields="tableFields" sort-by="prio" sort-direction="asc">
  <template slot="children" slot-scope="row">
      <span v-b-tooltip.hover title="Toggle child table"
        class="qa-children-column"
        v-if="isFolder(row.item)"
        @click="toggleDetails(row)">
        <span>[{{ row.item._showDetails ? '-' : '+' }}]</span>
        <span>({{row.item.children.length}})</span>
      </span>
    </template>
  <template slot="geo" slot-scope="row">
      <b-form-checkbox :unchecked-value="row.item.testname" :value="row.item" size="sm"/>
    </template>
  <template slot="qa_layer" slot-scope="row">
      <span v-show="testMap[row.item.qa_id] && !row.item.passed">
        <b-form-checkbox @change="filterFeatures(row.item.qa_id)" size="small" class="mb-sm-0 form-check-xs"></b-form-checkbox>
      </span>
    </template>

  <template slot="row-details" slot-scope="row" v-if="row.item._showDetails">
      <b-card>
        <!-- <h6 class="qa-children-header"></h6> -->
        <tree :batch="batch" :qaData="row.item.children" :tableFields="qaFields" :testMap="testMap" :layerFilter="filterFeatures">
        </tree>
      </b-card>
    </template>
</b-table>
</template>

<script>
import store from '../../store'

export default {
  name: 'tree',
  props: {
    batch: String,
    tableFields: Object,
    qaData: Array,
    testMap: Object,
    layerFilter: Function
  },
  data: function() {
    return {
      selectedTests: [],

      qaFields: {
        children: {
          label: 'Children'
        },
        testname: {
          label: 'testname',
          sortable: true
        },
        expected: {
          label: 'expected',
          sortable: false
        },
        op: {
          label: 'operator',
          sortable: false
        },
        count: {
          label: 'count',
          sortable: false
        },
        qa_layer: {
          label: 'QA Layer'
        }
      }
    }
  },
  computed: {
    filteredData() {
      return this.qaData.filter(v=> (v['batch_name'] === this.batch || v['workpack_wide']) && v['testname'])
    },
  },
  methods: {
    rowClicked (item, index, event) {
      this.$store.commit('project/selectedQa', item)
    },
    isFolder(v) {
      return v.children &&
        v.children.length
    },
    toggleDetails(v) {
      v.item._showDetails = !v.item._showDetails
    },
    filterFeatures(v) {
      if (this.selectedTests.indexOf(v) > -1) {
        this.selectedTests = this.selectedTests.filter(t => t !== v)
      } else {
        this.selectedTests.push(v)
      }
      this.layerFilter(v, 'qa_id')
    }
  },
  destroyed() {
    if (this.selectedTests.length) {
      this.selectedTests.forEach(t => {
        this.layerFilter(t, 'qa_id')
      })
      this.selectedTests = []
    }
  }
}
</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/map/tree.vue